import { Controller } from "@hotwired/stimulus"
import { Chart, BarController, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js"

Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip, Legend)

const DEFAULT_DATASETS = [
  { field: "delivered", label: "Delivered", color: "#22c55e" },
  { field: "received",  label: "Received",  color: "#3b82f6" },
  { field: "deferred",  label: "Deferred",  color: "#eab308" },
  { field: "bounced",   label: "Bounced",   color: "#f97316" },
  { field: "failed",    label: "Failed",    color: "#ef4444" },
]

export default class extends Controller {
  static values = { stats: Array, datasets: Array }

  connect() {
    const stats = this.statsValue
    const labels = stats.map(r => r.date)
    const defs = this.hasDatasetsValue && this.datasetsValue.length ? this.datasetsValue : DEFAULT_DATASETS

    const datasets = defs.map(d => ({
      label: d.label,
      data: stats.map(r => r[d.field] ?? 0),
      backgroundColor: d.color,
    }))

    new Chart(this.element, {
      type: "bar",
      data: { labels, datasets },
      options: {
        responsive: true,
        scales: {
          x: { stacked: true },
          y: { stacked: true, beginAtZero: true, ticks: { stepSize: 1 } }
        },
        plugins: {
          legend: { position: "bottom" }
        }
      }
    })
  }
}
